
import React from 'react';
import { WebSearchData } from '@/types/webSearch';

interface SourcesListProps {
  sources: WebSearchData['sources'];
}

const SourcesList: React.FC<SourcesListProps> = ({ sources }) => {
  if (!sources || sources.length === 0) {
    return <p className="text-muted-foreground py-2">No sources available.</p>;
  }

  const EXCLUDED_DOMAINS = [
    'crunchbase.com',
    'yelp.com',
    'yellowpages.com',
    'manta.com',
    'bbb.org',
    'zoominfo.com',
    'dnb.com',
    'bloomberg.com/profile'
  ];

  const uniqueSources = Array.from(
    new Set(sources.map(source => source.url))
  )
    .map(url => sources.find(source => source.url === url))
    .filter(source => {
      // Exclude business directory sources
      const isDirectory = EXCLUDED_DOMAINS.some(domain => 
        source?.url?.toLowerCase().includes(domain)
      );
      return !isDirectory;
    });

  // If no sources remain after filtering, show a message
  if (uniqueSources.length === 0) {
    return <p className="text-muted-foreground py-2">Sources filtered to show only official company information.</p>;
  }

  return (
    <div className="space-y-3">
      {uniqueSources.map((source, index) => (
        <div key={index} className="border rounded-md p-3">
          <a 
            href={source?.url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="font-medium text-blue-600 hover:underline"
          >
            {source?.title || 'Untitled Source'}
          </a>
          <p className="text-sm text-muted-foreground mt-1 truncate">{source?.url}</p>
        </div>
      ))}
    </div>
  );
};

export default SourcesList;
